var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5457 20.9039C35.7024 11.7661 30.0431 2.61013 20.9053 0.453421C11.7676 -1.70329 2.61159 3.95598 0.454875 13.0938C-1.70184 22.2315 3.95744 31.3875 13.0952 33.5442C22.233 35.7009 31.389 30.0417 33.5457 20.9039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1128_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 19.4286C18.3411 19.4286 19.4284 18.3412 19.4284 17C19.4284 15.6587 18.3411 14.5714 16.9999 14.5714C15.6586 14.5714 14.5713 15.6587 14.5713 17C14.5713 18.3412 15.6586 19.4286 16.9999 19.4286Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.126 9.71423H12.8731C11.1283 9.71423 9.71387 11.1287 9.71387 12.8734V21.1264C9.71387 22.8712 11.1283 24.2856 12.8731 24.2856H21.126C22.8708 24.2856 24.2852 22.8711 24.2852 21.1264V12.8734C24.2853 11.1287 22.8708 9.71423 21.126 9.71423ZM17.0165 20.9467C14.8745 20.9467 13.1319 19.2041 13.1319 17.0622C13.1319 14.9202 14.8745 13.1776 17.0165 13.1776C19.1584 13.1776 20.901 14.9202 20.901 17.0622C20.901 19.2041 19.1584 20.9467 17.0165 20.9467ZM21.0472 13.6699C20.6021 13.6699 20.2412 13.309 20.2412 12.8639C20.2412 12.4188 20.6021 12.0579 21.0472 12.0579C21.4923 12.0579 21.8532 12.4188 21.8532 12.8639C21.8532 13.309 21.4923 13.6699 21.0472 13.6699Z",
    fill: "#323232"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1128_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5714,
    height: 14.5714,
    fill: "white",
    transform: "translate(9.71387 9.71423)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramMobile);
export default __webpack_public_path__ + "static/media/instagram-mobile.b086d7d4a8f1473d9811f8f701fb8ea4.svg";
export { ForwardRef as ReactComponent };